import axios from 'axios'

class DesentranhamentoDocumentoAtaApi {
	async juntarTermoDesentranhamento(idDocumento) {
		return await axios.put(`api/atas/documentos/${idDocumento}/processo-digital/termo-desentranhamento`)
	}

	async criarTermoDesentranhamento(idDocumentoAta, idAditivoApostila = null) {
		return await axios.post(`api/atas/documentos/${idDocumentoAta}/gerar-termo-desentranhamento`, null, {
			params: { idAditivoApostila },
		})
	}
}

export default new DesentranhamentoDocumentoAtaApi()
